
import React from 'react';
import { Search, Map } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

interface SearchFilterBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedCounty: string | null;
  handleCountySelect: (county: string | null) => void;
  counties?: { county: string; county_slug: string }[];
  countiesLoading?: boolean;
}

export function SearchFilterBar({
  searchQuery,
  setSearchQuery,
  selectedCounty,
  handleCountySelect,
  counties = [],
  countiesLoading = false
}: SearchFilterBarProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-4 sm:p-6">
      <h3 className="font-medium text-lg mb-4 text-center sm:text-left">Search & Filter</h3>
      <div className="flex flex-col md:flex-row gap-5 items-stretch">
        <div className="w-full md:w-2/5">
          <Label htmlFor="search" className="text-sm font-medium mb-2 block">Search by name</Label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-grandpal-gray" size={18} />
            <Input
              id="search"
              type="text"
              placeholder="Search for a nursing home..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10 border-grandpal-beige focus-visible:ring-grandpal-green"
            />
          </div>
        </div>

        <div className="w-full md:w-2/5">
          <Label htmlFor="county-filter" className="text-sm font-medium mb-2 block">Filter by county</Label>
          <Select
            value={selectedCounty || "all"}
            onValueChange={(value) => handleCountySelect(value === "all" ? null : value)}
          >
            <SelectTrigger id="county-filter" className="border-grandpal-beige focus:ring-grandpal-green">
              <SelectValue placeholder="All counties" />
            </SelectTrigger>
            <SelectContent className="bg-white border-grandpal-beige">
              <SelectItem value="all">All counties</SelectItem>
              {!countiesLoading && counties?.map((item) => (
                <SelectItem key={item.county_slug} value={item.county_slug}>
                  {item.county}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        
        <div className="w-full md:w-1/5 mt-4 md:mt-0 flex justify-center md:justify-end">
          <Link to="/nursing-homes/map" className="w-full md:w-auto">
            <Button variant="outline" className="gap-2 border-grandpal-green hover:bg-grandpal-green-lighter hover:text-grandpal-green w-full">
              <Map size={18} />
              View Map
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
